import { NivosLanguages } from 'types/layout'

const DRAWER_WIDTH = 285

const NIVOS_LANGUAGES: NivosLanguages = {
  eng: {
    name: 'English',
    translations: {
      billboard: 'Billboard',
      amenityBooking: 'Amenity Booking',
      incidentReports: 'Incident Reports',
      createReport: 'Create Report',
      reporter: 'Reporter',
      status: 'Status',
      pending: 'Pending',
      resolved: 'Resolved',
      inProgress: 'In-Progress',
      details: 'Details',
      documents: 'Documents',
      messages: 'Messages',
      nightMode: 'Night mode',
      lightMode: 'Light mode',
      createReservation: 'Create Reservation',
      myBookings: 'My Bookings',
      recentDocuments: 'Recent Documents',
      newDocument: 'New Document',
      language: 'Language',
      search: 'Search',
      importantDates: 'Important Dates',
      importantNews: 'Important News',
      accountSettings: 'Account Settings',
      logout: 'Logout',
      admin: 'Admin'
    }
  },
  fr: {
    name: 'Français',
    translations: {
      billboard: 'Babillard',
      amenityBooking: 'Réservation de Services',
      incidentReports: "Rapports d'Incidents",
      createReport: 'Creer un Rapport',
      reporter: 'Créé par',
      status: 'Statut',
      pending: 'En attente',
      resolved: 'Résolu',
      inProgress: 'En cours',
      details: 'Détails',
      documents: 'Documents',
      messages: 'Messages',
      nightMode: 'Mode nuit',
      lightMode: 'Mode lumière',
      createReservation: 'Créer une Réservation',
      myBookings: 'Mes réservations',
      recentDocuments: 'Documents Récents',
      newDocument: 'Nouveau Document',
      language: 'Langue',
      search: 'Chercher',
      importantDates: 'Dates Importantes',
      importantNews: 'Nouvelles Importantes',
      accountSettings: 'Paramètres du compte',
      logout: 'Se déconnecter',
      admin: 'Administratrion'
    }
  }
}

export { DRAWER_WIDTH, NIVOS_LANGUAGES }
